/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { AttributeXWaitlistResponse, AttributeXWaitlistVars } from '../openapi-types.gen.js';

export type { AttributeXWaitlistResponse, AttributeXWaitlistVars } from '../openapi-types.gen.js';

export const useAttributeXWaitlist = createMutationHook<AttributeXWaitlistVars, AttributeXWaitlistResponse, unknown>({
  specName: 'useAttributeXWaitlist',
  path: '/v1/waitlist/x/attribute',
  method: 'POST',
  resolveUrl: (vars: AttributeXWaitlistVars) => `/v1/waitlist/x/attribute`,
  buildBody: (vars: AttributeXWaitlistVars) => ({ referralCode: vars.referralCode, locale: vars.locale }),
  parseResponse: (raw: unknown): AttributeXWaitlistResponse => raw as AttributeXWaitlistResponse,
  
  
  
});
